<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Terminal Batch Entries Upload</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AddEntriesToTerminalBatchForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import AddEntriesToTerminalBatchForm from "@/components/Kleyton/Forms/Terminal/AddEntriesToTerminalBatchForm";

export default {
  name: "AddEntriesToJournalBatch",
  page: {
    title: "Open Batch",
    meta: [{ name: "Open Batch", content: window.__env.app.description }]
  },

  components: {
    AddEntriesToTerminalBatchForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "Add Entries To Journal Batch",
      title: "Add Entries To Journal Batch",
      items: [
        {
          text: "Terminal",
          href: "/"
        },
        {
          text: "Upload Entries To Journal Batch",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
